var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37374 0C4.70009 0 4.96465 0.258771 4.96465 0.577982V0.963303H9.03535V0.577982C9.03535 0.258771 9.29991 0 9.62626 0C9.95261 0 10.2172 0.258771 10.2172 0.577982V0.963303H10.2828C12.0596 0.963303 13.5 2.37217 13.5 4.11009V10.8532C13.5 12.5911 12.0596 14 10.2828 14H3.71717C1.94038 14 0.5 12.5911 0.5 10.8532V4.11009C0.5 2.37217 1.94038 0.963303 3.71717 0.963303H3.78283V0.577982C3.78283 0.258771 4.04739 0 4.37374 0ZM3.78283 2.11927H3.71717C2.59308 2.11927 1.68182 3.01059 1.68182 4.11009V4.49541H12.3182V4.11009C12.3182 3.01059 11.4069 2.11927 10.2828 2.11927H10.2172V2.50459C10.2172 2.8238 9.95261 3.08257 9.62626 3.08257C9.29991 3.08257 9.03535 2.8238 9.03535 2.50459V2.11927H4.96465V2.50459C4.96465 2.8238 4.70009 3.08257 4.37374 3.08257C4.04739 3.08257 3.78283 2.8238 3.78283 2.50459V2.11927ZM12.3182 5.65138H1.68182V10.8532C1.68182 11.9527 2.59308 12.844 3.71717 12.844H10.2828C11.4069 12.844 12.3182 11.9527 12.3182 10.8532V5.65138Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.76109ba8e9f5f2b4936df45b98eb0fe7.svg";
export { ForwardRef as ReactComponent };